import { emitter } from "@finarkein/event-service";

export default emitter;